import { LeftOrRightAlignment } from "@mcleod/core";
import { AbstractGeneratedColumnHandler } from "./AbstractGeneratedColumnHandler";
import { ExpandTableCell } from "./ExpandTableCell";
import { ExpandTableColumn } from "./ExpandTableColumn";
import { TableCell } from "./TableCell";
import { TableRow } from "./TableRow";

export class ExpandHandler extends AbstractGeneratedColumnHandler {
    protected override createColumn(): ExpandTableColumn {
        return new ExpandTableColumn({ table: this.table });
    }

    protected override get columnAlignment(): LeftOrRightAlignment {
        return this.table.expandCellAlignment;
    }

    protected override getLogPath(): string {
        return "components.table.ExpandHandler";
    }

    protected override createPlaceholderCell(tableRow: TableRow): TableCell {
        return new ExpandTableCell({ table: this.table, row: tableRow });
    }
}
